import { render, staticRenderFns } from "./SectionTitleModal.vue?vue&type=template&id=2cd47246"
import script from "./SectionTitleModal.vue?vue&type=script&lang=js"
export * from "./SectionTitleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports